/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AccountActivation from '../components/AccountActivation';
import ArticleSectionImage from '../components/ArticleSectionImage';
import ArticleSectionMedia from '../components/ArticleSectionMedia';
import ArticleSectionRichText from '../components/ArticleSectionRichText';
import ArticleSectionTwoColumns from '../components/ArticleSectionTwoColumns';
import Commodities from '../components/Commodities';
import ContactUs from '../components/ContactUs';
import ContentBlock from '../components/ContentBlock';
import CreateAccount from '../components/CreateAccount';
import CreateCompanyForm from '../components/CreateCompanyForm';
import CreateContactForm from '../components/CreateContactForm';
import CreatePickup from '../components/CreatePickup';
import CreateQuoteForm from '../components/CreateQuoteForm';
import CreateSctnQuote from '../components/CreateSctnQuote';
import CreateShipment from '../components/CreateShipment';
import CreateUserForm from '../components/CreateUserForm';
import ErrorAccessDenied from '../components/ErrorAccessDenied';
import ErrorGeneral from '../components/ErrorGeneral';
import ExchangeRate from '../components/ExchangeRate';
import FetchGeneralSettings from '../components/FetchGeneralSettings';
import HomePageCopyBlock from '../components/HomePageCopyBlock';
import HomePageFooter from '../components/HomePageFooter';
import HomePageHeader from '../components/HomePageHeader';
import HomePageNews from '../components/HomePageNews';
import ImportExportForm from '../components/ImportExportForm';
import LoginForm from '../components/LoginForm';
import Logout from '../components/Logout';
import ManageClaims from '../components/ManageClaims';
import ManageCompanies from '../components/ManageCompanies';
import ManageContacts from '../components/ManageContacts';
import ManageInvoices from '../components/ManageInvoices';
import ManageOrders from '../components/ManageOrders';
import ManagePickups from '../components/ManagePickups';
import ManageQuotes from '../components/ManageQuotes';
import ManageShipments from '../components/ManageShipments';
import ManageUsers from '../components/ManageUsers';
import Navigation from '../components/Navigation';
import NewsCarousel from '../components/NewsCarousel';
import NotFoundContent from '../components/NotFoundContent';
import PasswordReset from '../components/PasswordReset';
import RoleBasedButton from '../components/RoleBasedButton';
import SecondaryNavigation from '../components/SecondaryNavigation';
import SessionTimeoutModal from '../components/SessionTimeoutModal';
import ShowActions from '../components/ShowActions';
import ShowProfile from '../components/ShowProfile';
import SiteSearch from '../components/SiteSearch';
import StaticPageSublayout from '../components/StaticPageSublayout';
import Stories from '../components/Stories';
import SubmitClaimForm from '../components/SubmitClaimForm';
import SubmitFeedback from '../components/SubmitFeedback';
import TerminalLocation from '../components/TerminalLocation';
import TrackShipment from '../components/TrackShipment';
import TransitTimeCalculator from '../components/TransitTimeCalculator';
import UpdatesAlert from '../components/UpdatesAlert';
import UserProfileForm from '../components/UserProfileForm';
import ViewOrder from '../components/ViewOrder';
import ViewQuotePage from '../components/ViewQuotePage';
import ViewShipmentPage from '../components/ViewShipmentPage';
import ViewShipmentTracking from '../components/ViewShipmentTracking';
import ViewUserDashboard from '../components/ViewUserDashboard';
import VolumeDensityCalculator from '../components/VolumeDensityCalculator';

const components = new Map();
components.set('AccountActivation', AccountActivation);
components.set('ArticleSectionImage', ArticleSectionImage);
components.set('ArticleSectionMedia', ArticleSectionMedia);
components.set('ArticleSectionRichText', ArticleSectionRichText);
components.set('ArticleSectionTwoColumns', ArticleSectionTwoColumns);
components.set('Commodities', Commodities);
components.set('ContactUs', ContactUs);
components.set('ContentBlock', ContentBlock);
components.set('CreateAccount', CreateAccount);
components.set('CreateCompanyForm', CreateCompanyForm);
components.set('CreateContactForm', CreateContactForm);
components.set('CreatePickup', CreatePickup);
components.set('CreateQuoteForm', CreateQuoteForm);
components.set('CreateSctnQuote', CreateSctnQuote);
components.set('CreateShipment', CreateShipment);
components.set('CreateUserForm', CreateUserForm);
components.set('ErrorAccessDenied', ErrorAccessDenied);
components.set('ErrorGeneral', ErrorGeneral);
components.set('ExchangeRate', ExchangeRate);
components.set('FetchGeneralSettings', FetchGeneralSettings);
components.set('HomePageCopyBlock', HomePageCopyBlock);
components.set('HomePageFooter', HomePageFooter);
components.set('HomePageHeader', HomePageHeader);
components.set('HomePageNews', HomePageNews);
components.set('ImportExportForm', ImportExportForm);
components.set('LoginForm', LoginForm);
components.set('Logout', Logout);
components.set('ManageClaims', ManageClaims);
components.set('ManageCompanies', ManageCompanies);
components.set('ManageContacts', ManageContacts);
components.set('ManageInvoices', ManageInvoices);
components.set('ManageOrders', ManageOrders);
components.set('ManagePickups', ManagePickups);
components.set('ManageQuotes', ManageQuotes);
components.set('ManageShipments', ManageShipments);
components.set('ManageUsers', ManageUsers);
components.set('Navigation', Navigation);
components.set('NewsCarousel', NewsCarousel);
components.set('NotFoundContent', NotFoundContent);
components.set('PasswordReset', PasswordReset);
components.set('RoleBasedButton', RoleBasedButton);
components.set('SecondaryNavigation', SecondaryNavigation);
components.set('SessionTimeoutModal', SessionTimeoutModal);
components.set('ShowActions', ShowActions);
components.set('ShowProfile', ShowProfile);
components.set('SiteSearch', SiteSearch);
components.set('StaticPageSublayout', StaticPageSublayout);
components.set('Stories', Stories);
components.set('SubmitClaimForm', SubmitClaimForm);
components.set('SubmitFeedback', SubmitFeedback);
components.set('TerminalLocation', TerminalLocation);
components.set('TrackShipment', TrackShipment);
components.set('TransitTimeCalculator', TransitTimeCalculator);
components.set('UpdatesAlert', UpdatesAlert);
components.set('UserProfileForm', UserProfileForm);
components.set('ViewOrder', ViewOrder);
components.set('ViewQuotePage', ViewQuotePage);
components.set('ViewShipmentPage', ViewShipmentPage);
components.set('ViewShipmentTracking', ViewShipmentTracking);
components.set('ViewUserDashboard', ViewUserDashboard);
components.set('VolumeDensityCalculator', VolumeDensityCalculator);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
